import React, { useEffect, useState } from 'react'
import DashboardSummary from '../DashboardSummaryNew';
import DashboardGroupedBarChart from "../DashboardGroupedBarChart";
import DashboardLineChart from '../DashboardLineChart';
import DashboardTable from '../DashboardTable';
import callPostApi from "../../../requests/PostRequests";
import callGetApi from "../../../requests/GetRequests"
import * as Constants from '../../../requests/URLConstants';
import * as tableHeaders from './tableHeaders';
import moment from 'moment';
import * as DashboardUtils from '../DashboardUtils.js';
import TableToolbarDownload from '../../../common/TableToolbarDownload';
import * as DashboardConstants from '.././DashboardConstants';
import * as workspaces from '../../../config/WorkspaceConstants'
import * as IncidentDetailsUtil from '../../../components/IncidentDetails/IncidentDetailsUtil'
import * as config from "../../../config/Constants";

require("../_dashboard.scss");
require("./_sla-compliance.scss");


const SLACompliance = (props) => {
    const [slaTicketResponseDataLoading, setSlaTicketResponseDataLoading] = useState(true);
    const [slaTicketResponseData, setSlaTicketResponseData] = useState([]);
    const [slaTicketResolutionDataLoading, setSlaTicketResolutionDataLoading] = useState(true);
    const [slaTicketResolutionData, setSlaTicketResolutionData] = useState([]);
    const [slaTicketTableDataLoading, setSlaTicketTableDataLoading] = useState(true);
    const [slaTicketTableData, setSlaTicketTableData] = useState([]);
    const [terminationTrendsLoading, setTerminationTrendsLoading] = useState(true);
    const [terminationTrendsData, setTerminationTrendsData] = useState([]);
    const [slaByFranchiseLoading, setSlaByFranchiseLoading] = useState(true);
    const [slaFranchiseResponseData, setSlaFranchiseResponseData] = useState([]);
    const [slaFranchiseResolutionData, setSlaFranchiseResolutionData] = useState([]);
    const [slaFranchiseTableData, setSlaFranchiseTableData] = useState([]);
    const [slaSummaryData, setSlaSummaryData] = useState([]);
    const [slaByIncidentLoading, setSlaByIncidentLoading] = useState(false);
    const [slaByIncidentData, setSlaByIncidentData] = useState([]);
    const [slaByIncidentDownloadData, setSlaByIncidentDownloadData] = useState([]);
    const [AssignmentGroupData, setAssignmentGroupData] = useState([]);
    const [IncidentStateData, setIncidentStateData] = useState([]);
    const [IncidentResponse, setIncidentResponse] = useState([]);
    const [TotalItems, setTotalItems] = useState(0);
    const [count, setCount] = useState(0);

    const slaTicketYAxisthresholds = [{ "value": 95, "label": "Threshold", "fillColor": "orange" }];

    const getSlaSummary = (param) => {
        let summary = [
            {
                title: DashboardConstants.AverageResponseSLAMet,
                value: param.averageResponseSla,
                showPercent: true
            },
            {
                title: DashboardConstants.AverageResolutionSLAMet,
                value: param.averageResolutionSla,
                showPercent: true
            }
        ];
        setSlaSummaryData(summary);
    };

    useEffect(() => {
        getSLATicketResponse(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.filterSelectionsSalesforce, props.workspace);
        getSLATicketResolution(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.filterSelectionsSalesforce, props.workspace);
        getSLATicketResponseResolution(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.filterSelectionsSalesforce, props.workspace);
        getSLAByFranchiseResponseResolution(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.filterSelectionsSalesforce, props.workspace);
        getSLATrend(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.filterSelectionsSalesforce, props.workspace);
        getIncidentState(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.filterSelectionsSalesforce, props.workspace);
        getIncidentGroup(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.filterSelectionsSalesforce, props.workspace);
    }, [props.preferencesChanged]);

    useEffect(() => {
        //console.log(IncidentResponse)
        let data = prepareSlaIncidentData(IncidentResponse);
        setSlaByIncidentData(data.tableData);
        setSlaByIncidentDownloadData(data.downloadableData);
    }, [IncidentResponse])

    useEffect(() => {
        if (config.URL.includes(config.unilever)) {
            if (AssignmentGroupData && AssignmentGroupData.length > 0 && IncidentStateData && IncidentStateData.length > 0) {
                TotalItems && TotalItems > 0 && getSLAByIncident(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.filterSelectionsSalesforce, props.workspace, 10, 0);
                getSLATotalIncidents(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.filterSelectionsSalesforce, props.workspace);
            }
        }
    }, [props.preferencesChanged, AssignmentGroupData, IncidentStateData, TotalItems]);

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;

        if (workspace === workspaces.automation_ops) {
            technology = dashboardFilterSelectionsAutomation.technology;
            franchise = dashboardFilterSelectionsAutomation.franchise;
            client = dashboardFilterSelectionsAutomation.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
                    "business_competencies": dashboardFilterSelectionsAutomation.competency,
                    "incident_status": dashboardFilterSelectionsAutomation.incident_status,
                    "assignment_groups": dashboardFilterSelectionsAutomation.assignment_group,
                    "process_name": dashboardFilterSelectionsAutomation.process_name
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        }
        else if (workspace === workspaces.salesforce_ops) {
            technology = ["Salesforce"];
            franchise = dashboardFilterSelectionsSalesforce.franchise;
            client = dashboardFilterSelectionsSalesforce.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace,
            };
        }
        else {
            technology = ["SAP"];
            franchise = dashboardFilterSelectionsSAP.franchise;
            client = dashboardFilterSelectionsSAP.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "assignment_groups": dashboardFilterSelectionsSAP.assignment_group,
                    "incident_status": dashboardFilterSelectionsSAP.incident_status,
                    "automata_priority": dashboardFilterSelectionsSAP.priority
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        }

        return bodyJSON;
    };

    const prepareSlaTicketData = (response, type) => {
        let graphData = [];
        let graphObj = {};
        let summaryData = 0;
        let value;
        if (response) {
            let buckets = response.aggregations["2"].buckets;
            for (let i = 0; i < buckets.length; i++) {
                for (let j = 0; j < buckets[i]["3"].buckets.length; j++) {
                    value = type === "response" ? buckets[i]["3"].buckets[j].response_sla.value : buckets[i]["3"].buckets[j].resolution_sla.value
                    graphObj = {
                        group: buckets[i]["3"].buckets[j].key,
                        key: buckets[i].key_as_string ? moment(new Date(buckets[i].key_as_string)).format("YYYY-MM-DD") : '',
                        value: value
                    };
                    graphData.push(graphObj);
                }
            }
        }
        return { graphData, summaryData };
    };

    const getSLATicketResponse = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
            setSlaTicketResponseDataLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
            callPostApi(Constants.GETSLATICKETRESPONSE, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareSlaTicketData(resp, "response");
                    setSlaTicketResponseData(formattedData.graphData);
                    setSlaTicketResponseDataLoading(false);
                }).catch((error) => {
                    setSlaTicketResponseDataLoading(false);
                });
        }
    }

    const getSLATicketResolution = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
            setSlaTicketResolutionDataLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
            callPostApi(Constants.GETSLATICKETRESOLUTION, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareSlaTicketData(resp, "resolution");
                    setSlaTicketResolutionData(formattedData.graphData);
                    setSlaTicketResolutionDataLoading(false);
                }).catch((error) => {
                    setSlaTicketResolutionDataLoading(false);
                });
        }
    }

    const prepareSlaTicketTableData = (response) => {
        let tableData = [];
        let tableObj = {};
        let expandedItemObj = {};
        let expandedTable = [];
        let statusBucket = [];
        let summaryData = {
            averageResponseSla: 0,
            averageResolutionSla: 0
        };
        let averageResolutionSla = 0, averageResponseSla = 0;
        let responseTotal = 0, resolutionTotal = 0, averageResponsePercentage = 0, averageResolutionPercentage = 0;
        if (response) {
            statusBucket = [];
            let buckets = response.aggregations["3"].buckets;
            for (let i = 0; i < buckets.length; i++) {
                responseTotal = 0;
                resolutionTotal = 0;
                averageResponsePercentage = 0;
                averageResolutionPercentage = 0;
                expandedTable = [];
                tableObj = {
                    id: i + 1,
                    item: buckets[i].key_as_string ? moment(new Date(buckets[i].key_as_string)).format("YYYY-MM-DD") : '',
                    total: buckets[i].doc_count,
                };
                statusBucket = buckets[i].automata_priority.buckets;
                for (let j = 0; j < statusBucket.length; j++) {
                    responseTotal = responseTotal + statusBucket[j].response_sla.value;
                    resolutionTotal = resolutionTotal + statusBucket[j].resolution_sla.value;
                    averageResponsePercentage = averageResponsePercentage + statusBucket[j].response_sla_per.value;
                    averageResolutionPercentage = averageResolutionPercentage + statusBucket[j].resolution_sla_per.value;
                    expandedItemObj = {
                        id: j + 1,
                        item: statusBucket[j].key,
                        total: statusBucket[j].doc_count,
                        response: statusBucket[j].response_sla.value,
                        resolution: statusBucket[j].resolution_sla.value,
                        responsePercentage: (statusBucket[j].response_sla_per.value).toFixed(2),
                        resolutionPercentage: (statusBucket[j].resolution_sla_per.value).toFixed(2)
                    }
                    expandedTable.push(expandedItemObj);
                }
                tableObj.response = responseTotal;
                tableObj.resolution = resolutionTotal;
                tableObj.responsePercentage = (averageResponsePercentage / statusBucket.length).toFixed(2);
                tableObj.resolutionPercentage = (averageResolutionPercentage / statusBucket.length).toFixed(2);
                tableObj.expandedItems = expandedTable;
                tableData.push(tableObj);
                averageResolutionSla = averageResolutionSla + parseInt(tableObj.resolutionPercentage);
                averageResponseSla = averageResponseSla + parseInt(tableObj.responsePercentage);
            }
            averageResolutionSla = Math.round(averageResolutionSla / tableData.length);
            averageResponseSla = Math.round(averageResponseSla / tableData.length);
            summaryData.averageResolutionSla = isNaN(averageResolutionSla) ? '-' : averageResolutionSla;
            summaryData.averageResponseSla = isNaN(averageResponseSla) ? '-' : averageResponseSla;
        }
        return { tableData, summaryData };
    }
    const getSLATicketResponseResolution = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
            setSlaTicketTableDataLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
            callPostApi(Constants.GETSLATICKETRESPONSERESOLUTION, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareSlaTicketTableData(resp);
                    setSlaTicketTableData(formattedData.tableData);
                    getSlaSummary(formattedData.summaryData)
                    setSlaTicketTableDataLoading(false);
                }).catch((error) => {
                    setSlaTicketTableDataLoading(false);
                });
        }
    }

    const prepareSlaFranchiseData = (response) => {
        if (response) {
            let responseGraphData = [];
            let resolutionGraphData = [];
            let reponseGraphObj = {};
            let resolutionGraphObj = {};
            let statusBucket = [];
            let tableData = [];
            let tableObj = {};
            let expandedItemObj = {};
            let expandedTable = [];
            let total = 0, responseTotal = 0, resolutionTotal = 0,
                averageResponsePercentage = 0, averageResolutionPercentage = 0;
            if (response) {
                let buckets = response.aggregations.franchise.buckets;
                for (let i = 0; i < buckets.length; i++) {
                    total = 0;
                    responseTotal = 0;
                    resolutionTotal = 0;
                    averageResponsePercentage = 0;
                    averageResolutionPercentage = 0;
                    expandedTable = [];
                    tableObj = {
                        id: i + 1,
                        item: buckets[i].key
                    }
                    statusBucket = buckets[i].automata_priority.buckets;
                    for (let j = 0; j < statusBucket.length; j++) {
                        reponseGraphObj = {
                            key: buckets[i].key,
                            group: statusBucket[j].key,
                            value: statusBucket[j].automata_response_sla_per.value
                        };
                        resolutionGraphObj = {
                            key: buckets[i].key,
                            group: statusBucket[j].key,
                            value: statusBucket[j].automata_resolution_sla_per.value
                        };
                        total = total + statusBucket[j].doc_count;
                        responseTotal = responseTotal + statusBucket[j].automata_response_sla.value;
                        resolutionTotal = resolutionTotal + statusBucket[j].automata_resolution_sla.value;
                        averageResponsePercentage = averageResponsePercentage + statusBucket[j].automata_response_sla_per.value;
                        averageResolutionPercentage = averageResolutionPercentage + statusBucket[j].automata_resolution_sla_per.value;
                        expandedItemObj = {
                            id: j + 1,
                            item: statusBucket[j].key,
                            total: statusBucket[j].doc_count,
                            response: statusBucket[j].automata_response_sla.value,
                            resolution: statusBucket[j].automata_resolution_sla.value,
                            responsePercentage: statusBucket[j].automata_response_sla_per.value ? (statusBucket[j].automata_response_sla_per.value).toFixed(2) : '',
                            resolutionPercentage: statusBucket[j].automata_resolution_sla_per ? (statusBucket[j].automata_resolution_sla_per.value).toFixed(2) : '',
                        }
                        expandedTable.push(expandedItemObj);
                        responseGraphData.push(reponseGraphObj);
                        resolutionGraphData.push(resolutionGraphObj);
                    }
                    tableObj.total = total;
                    tableObj.response = responseTotal;
                    tableObj.resolution = resolutionTotal;
                    tableObj.responsePercentage = averageResponsePercentage ? (averageResponsePercentage / statusBucket.length).toFixed(2) : '-';
                    tableObj.resolutionPercentage = averageResolutionPercentage ? (averageResolutionPercentage / statusBucket.length).toFixed(2) : '-';
                    tableObj.expandedItems = expandedTable;
                    tableData.push(tableObj);
                }
            }
            return { responseGraphData, resolutionGraphData, tableData };
        }
    };

    const getSLAByFranchiseResponseResolution = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
            setSlaByFranchiseLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
            callPostApi(Constants.GETSLABYFRANCHISERESPONSERESOLUTION, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareSlaFranchiseData(resp);
                    setSlaFranchiseResolutionData(formattedData.resolutionGraphData);
                    setSlaFranchiseResponseData(formattedData.responseGraphData);
                    setSlaFranchiseTableData(formattedData.tableData);
                    setSlaByFranchiseLoading(false);
                }).catch((error) => {
                    setSlaByFranchiseLoading(false);
                });
        }
    }

    const prepareTerminationTrendsData = (response) => {
        let graphData = [];
        let reponseGraphObj = {};
        let resolutionGraphObj = {};
        if (response) {
            let buckets = response.aggregations["2"].buckets;
            for (let i = 0; i < buckets.length; i++) {
                reponseGraphObj = {
                    group: "Response",
                    date: buckets[i].key_as_string ? moment(new Date(buckets[i].key_as_string)).format("YYYY-MM-DD") : '',
                    value: buckets[i].response_per.value,
                };
                resolutionGraphObj = {
                    group: "Resolution",
                    date: buckets[i].key_as_string ? moment(new Date(buckets[i].key_as_string)).format("YYYY-MM-DD") : '',
                    value: buckets[i].resolution_per.value,
                }
                graphData.push(reponseGraphObj);
                graphData.push(resolutionGraphObj);
            }
        }
        return graphData;
    };

    const getSLATrend = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
            setTerminationTrendsLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
            callPostApi(Constants.GETSLATREND, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareTerminationTrendsData(resp);
                    setTerminationTrendsData(formattedData);
                    setTerminationTrendsLoading(false);
                }).catch((error) => {
                    setTerminationTrendsLoading(false);
                });
        }
    }

    const prepareSlaIncidentData = (response) => {
        let tableObj = {};
        let tableData = [];
        let downloadableObj = {};
        let downloadableData = [];
        if (response) {
            let buckets = response;
            for (let i = 0; i < buckets.length; i++) {

                //Onhold duration calculation
                let OnHoldDuration = buckets[i].on_hold_duration ? buckets[i].on_hold_duration : "";
                let OnHoldDays = 0, OnHoldHours = 0, OnHoldMinutes = 0, OnHoldSeconds = 0;
                let daysincluded = OnHoldDuration.includes("Days") ? "Days" : "Day"; //check if string has days
                let hourincluded = OnHoldDuration.includes("Hours") ? "Hours" : "Hour";//check if string has hours
                let minincluded = OnHoldDuration.includes("Minutes") ? "Minutes" : "Minute";//check if string has minutes
                let secincluded = OnHoldDuration.includes("Seconds") ? "Seconds" : "Second";//check if string has seconds

                let hoursposition = hourincluded === "Hours" ? 6 : 5; //position for slice function
                let daysposition = daysincluded === "Days" ? 5 : 4; //position for slice function
                let secondsposition = secincluded === "Seconds" ? 7 : 6; //position for slice function

                // If else condition to fetch days, hours, months and seconds from the string
                if (OnHoldDuration.includes("Days") || OnHoldDuration.includes("Day")) {
                    OnHoldDays = OnHoldDuration.split(daysincluded)[0].trim();
                    OnHoldHours = OnHoldDuration.slice(OnHoldDuration.indexOf(daysincluded) + daysposition, OnHoldDuration.lastIndexOf(hourincluded)).trim();;
                    OnHoldMinutes = OnHoldDuration.slice(OnHoldDuration.indexOf(hourincluded) + hoursposition, OnHoldDuration.lastIndexOf(minincluded)).trim();;
                    OnHoldSeconds = OnHoldDuration.slice(OnHoldDuration.indexOf(minincluded) + secondsposition, OnHoldDuration.lastIndexOf(secincluded)).trim();

                }
                else if (OnHoldDuration.includes("Hours") || OnHoldDuration.includes("Hour")) {
                    OnHoldDays = 0;
                    OnHoldHours = OnHoldDuration.split(hourincluded)[0].trim();
                    OnHoldMinutes = parseInt(OnHoldDuration.slice(OnHoldDuration.indexOf(hourincluded) + hoursposition, OnHoldDuration.lastIndexOf(minincluded)))
                    OnHoldSeconds = OnHoldDuration.slice(OnHoldDuration.indexOf(minincluded) + secondsposition, OnHoldDuration.lastIndexOf(secincluded)).trim();

                }
                else if (OnHoldDuration.includes("Minutes") || OnHoldDuration.includes("Minute")) {
                    OnHoldDays = 0;
                    OnHoldHours = 0;
                    OnHoldMinutes = OnHoldDuration.split(minincluded)[0].trim();
                    OnHoldSeconds = OnHoldDuration.slice(OnHoldDuration.indexOf(minincluded) + secondsposition, OnHoldDuration.lastIndexOf(secincluded)).trim();
                }
                else if (OnHoldDuration.includes("Seconds") || OnHoldDuration.includes("Second")) {
                    OnHoldDays = 0;
                    OnHoldHours = 0
                    OnHoldMinutes = 0
                    OnHoldSeconds = OnHoldDuration.split(secincluded)[0].trim();
                }
                else {
                    OnHoldDays = 0;
                    OnHoldHours = 0;
                    OnHoldMinutes = 0;
                    OnHoldSeconds = 0;
                }

                let start = moment(new Date(buckets[i].created_time)); //startdate
                let end = moment(new Date(buckets[i].resolved_time)).subtract(OnHoldHours, 'hours').subtract(OnHoldDays, 'days').subtract(OnHoldMinutes, 'minutes').subtract(OnHoldSeconds, "seconds");  //enddate with subtracted hold duration
                let totalMins = end.diff(start, 'minutes'); //totalminutes
                let totalHours = end.diff(start, 'hours'); //totalhours
                let totalDays = end.diff(start, 'days'); //totaldays
                let duration = moment.duration(end.diff(start)); //totalduration
                let hours = duration.hours() > 1 ? `${duration.hours()} hours` : `${duration.hours()} hour`; //total duration hours
                let minutes = duration.minutes() > 1 ? `${duration.minutes()} mins` : `${duration.minutes()} min`; //total duration minutes
                let days = totalDays > 1 ? `${totalDays} days` : `${totalDays} day`; //total duration days

                let resolvedDuration;
                if (totalMins >= 0 && totalMins < 60) {
                    resolvedDuration = `Resolved in ${minutes}`;
                }
                else if (totalMins >= 60 && totalHours < 24) {
                    resolvedDuration = `Resolved in ${hours} ${minutes}`;
                }
                else if (totalMins >= 60 && totalHours >= 24) {
                    resolvedDuration = `Resolved in ${days} ${hours} ${minutes}`;
                }
                else {
                    resolvedDuration = `Resolved in ${0} min`
                }
                tableObj = {
                    id: (i + 1).toString(),
                    incident_no: buckets[i].incident_no,
                    status: buckets[i].status,
                    created_time: buckets[i].created_time ? moment(new Date(buckets[i].created_time)).format("DD MMM YY | HH:mm") : '-',
                    assigned_time: buckets[i].assigned_time ? moment(new Date(buckets[i].assigned_time)).format("DD MMM YY | HH:mm") : '-',
                    resolved_time: <div>
                        <div>{buckets[i].resolved_time ? moment(new Date(buckets[i].resolved_time)).format("DD MMM YY | HH:mm") : '-'}</div>
                        <div className='resolved-time'>{buckets[i].resolved_time && buckets[i].created_time ? resolvedDuration : ''}</div></div>,
                    on_hold_duration: buckets[i].on_hold_duration ? buckets[i].on_hold_duration : "-",
                    resolved_duration: resolvedDuration
                }
                downloadableObj = {
                    id: (i + 1).toString(),
                    incident_no: buckets[i].incident_no,
                    status: buckets[i].status,
                    created_time: buckets[i].created_time ? moment(new Date(buckets[i].created_time)).format("DD/MMM/YY HH:mm") : '-',
                    assigned_time: buckets[i].assigned_time ? moment(new Date(buckets[i].assigned_time)).format("DD/MMM/YY HH:mm") : '-',
                    resolved_time: buckets[i].resolved_time ? moment(new Date(buckets[i].resolved_time)).format("DD/MMM/YY HH:mm") : '-',
                    on_hold_duration: buckets[i].on_hold_duration ? buckets[i].on_hold_duration : "-",
                    resolved_duration: resolvedDuration
                }
                tableData.push(tableObj);
                downloadableData.push(downloadableObj);
            }
        }
        return { tableData, downloadableData }
    };

    const getSLAByIncident = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, limit, offset, clickType) => {
        //console.log("offset", offset, limit)
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
            setSlaByIncidentLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
            let startDate = moment(props.timeFilterSelections.startDateTime).format('YYYY-MM-DD');
            let endDate = moment(props.timeFilterSelections.endDateTime).format('YYYY-MM-DD');
            let startDateTime = moment(props.timeFilterSelections.startDateTime).format('HH:mm:ss');
            let endDateTime = moment(props.timeFilterSelections.endDateTime).format('HH:mm:ss');

            let franchise = bodyJSON.filters.franchises && bodyJSON.filters.franchises.length > 0 ? bodyJSON.filters.franchises : null;
            let client = bodyJSON.filters.clients && bodyJSON.filters.clients.length > 0 ? bodyJSON.filters.clients : null;
            let selectedPriority = bodyJSON.filters.automata_priority && bodyJSON.filters.automata_priority.length > 0 ? bodyJSON.filters.automata_priority : null;
            let incident_state = bodyJSON.filters.incident_status && bodyJSON.filters.incident_status.length > 0 ? bodyJSON.filters.incident_status : null;
            let assignment_group = bodyJSON.filters.assignment_groups && bodyJSON.filters.assignment_groups.length > 0 ? bodyJSON.filters.assignment_groups : null;
            let AssignmentGroupArray = AssignmentGroupData && AssignmentGroupData.length > 0 ? AssignmentGroupData.filter(element => assignment_group && assignment_group.includes(element.name)).map(res => res.sys_id) : null;
            let IncidentStateArray = IncidentStateData && IncidentStateData.length > 0 ? IncidentStateData.filter(element => incident_state && incident_state.includes(element.label)).map(res => res.value) : null;
            let IncArray = IncidentStateArray && IncidentStateArray.length > 0 ? IncidentStateArray : null;
            let AsmtArray = AssignmentGroupArray && AssignmentGroupArray.length > 0 ? AssignmentGroupArray : null;
            let priority = selectedPriority ? selectedPriority.map(val => val.match(/\d/g).join('')) : null;

            callGetApi(Constants.GETSLAINCIDENTS + `/${startDate}/${endDate}/${startDateTime}/${endDateTime}/${franchise}/${client}/${priority}/${IncArray}/${AsmtArray}/${limit}/${offset}`, {
                'Content-Type': 'application/json'
            })
                .then(resp => {
                    clickType === "next" ? setIncidentResponse(item => [...item, ...resp]) : setIncidentResponse(resp)
                    setSlaByIncidentLoading(false);
                }).catch((error) => {
                    setSlaByIncidentLoading(false);
                });
        }
    }


    const getSLATotalIncidents = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {

            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
            let startDate = moment(props.timeFilterSelections.startDateTime).format('YYYY-MM-DD');
            let endDate = moment(props.timeFilterSelections.endDateTime).format('YYYY-MM-DD');
            let startDateTime = moment(props.timeFilterSelections.startDateTime).format('HH:mm:ss');
            let endDateTime = moment(props.timeFilterSelections.endDateTime).format('HH:mm:ss');
            let franchise = bodyJSON.filters.franchises && bodyJSON.filters.franchises.length > 0 ? bodyJSON.filters.franchises : null;
            let client = bodyJSON.filters.clients && bodyJSON.filters.clients.length > 0 ? bodyJSON.filters.clients : null;
            let selectedPriority = bodyJSON.filters.automata_priority && bodyJSON.filters.automata_priority.length > 0 ? bodyJSON.filters.automata_priority : null;
            let incident_state = bodyJSON.filters.incident_status && bodyJSON.filters.incident_status.length > 0 ? bodyJSON.filters.incident_status : null;
            let assignment_group = bodyJSON.filters.assignment_groups && bodyJSON.filters.assignment_groups.length > 0 ? bodyJSON.filters.assignment_groups : null;
            let AssignmentGroupArray = AssignmentGroupData && AssignmentGroupData.length > 0 ? AssignmentGroupData.filter(element => assignment_group && assignment_group.includes(element.name)).map(res => res.sys_id) : null;
            let IncidentStateArray = IncidentStateData && IncidentStateData.length > 0 ? IncidentStateData.filter(element => incident_state && incident_state.includes(element.label)).map(res => res.value) : null;
            let IncArray = IncidentStateArray && IncidentStateArray.length > 0 ? IncidentStateArray : null;
            let AsmtArray = AssignmentGroupArray && AssignmentGroupArray.length > 0 ? AssignmentGroupArray : null;
            let priority = selectedPriority ? selectedPriority.map(val => val.match(/\d/g).join('')) : null;

            callGetApi(Constants.GETSLATOTALINCIDENTS + `/${startDate}/${endDate}/${startDateTime}/${endDateTime}/${franchise}/${client}/${priority}/${IncArray}/${AsmtArray}`, {
                'Content-Type': 'application/json'
            })
                .then(resp => {
                    setTotalItems(resp);
                }).catch((error) => {
                    setTotalItems(0);
                });

        }
    }

    const getIncidentState = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {

        //let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
        //let client = bodyJSON.filters.clients && bodyJSON.filters.clients.length > 0 ? bodyJSON.filters.clients : null;
        let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
        let clientToSend = 'Unilever' //IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, client);
        let url = Constants.GETSLAINCIDENTSTATE + '/' + clientToSend + '/' + workspaceToSend;
        callGetApi(url, {
            'Content-Type': 'application/json'
        })
            .then(resp => {
                setIncidentStateData(resp.result);
            })
            .catch((error) => {
                setIncidentStateData([]);
            });
    }

    const getIncidentGroup = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        //let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
        //let client = bodyJSON.filters.clients && bodyJSON.filters.clients.length > 0 ? bodyJSON.filters.clients : null;
        let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
        let clientToSend = 'Unilever' //IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, client);
        let url = Constants.GETASSIGNMENTGROUP + clientToSend + '/' + workspaceToSend;
        callGetApi(url, {
            'Content-Type': 'application/json'
        })
            .then(resp => {
                setAssignmentGroupData(resp.result);
            })
            .catch((error) => {
                setAssignmentGroupData([]);
            });
    }

    function getPages(total, current) {
        // setCurrentPage(current ? current : 0);
        //setTotalPages(total ? total : 0);
        console.log("pages", total, current, total === current)
    }

    function handleNextClick() {
        setCount(count + 10);
        getSLAByIncident(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.filterSelectionsSalesforce, props.workspace, 10, count + 10, 'next');
    }

    return (
        <div className="top-margin dashboard sla-compliance">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-roleContainer col-lg-12">
                    <DashboardSummary loading={slaTicketTableDataLoading} summary={slaSummaryData} title={DashboardConstants.SLACompliance} />
                </div>
                <div className="dashboard-charts-container">
                    <div className="report-title">
                        <div>{DashboardConstants.DetailedView}</div>
                    </div>
                    <section className="border-bottom">
                        <DashboardLineChart
                            lineGraphData={terminationTrendsData}
                            loading={terminationTrendsLoading}
                            title={DashboardConstants.ResolutionAndResponseSLATrend}
                            graphTitle={DashboardConstants.ResolutionResponseSLA}
                        />
                    </section>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.ResolutionAndResponseSLATrend}</div>
                            <div className="download-button">
                                <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={slaTicketTableData} headers={tableHeaders.slaByPriorityTableHeaders} title={DashboardConstants.ResolutionAndResponseSLATrend} filename={DashboardConstants.Export} label={DashboardConstants.TicketSeverity} />
                            </div>
                        </div>
                        <div className="tile-view">
                            <div className="report-container">
                                <DashboardGroupedBarChart
                                    loading={slaTicketResponseDataLoading}
                                    groupedBarChartData={slaTicketResponseData}
                                    graphAxesTitle={DashboardConstants.ResponseSLAMet}
                                    graphBottomTitle={DashboardConstants.Time}
                                    yAxisthresholds={slaTicketYAxisthresholds}
                                    isPercentage={true}
                                    headers={tableHeaders.slaTicketResponseDownloadbaleHeader}
                                    hideDownloadButton={true}
                                    toolbarEnabled={true}
                                />
                            </div>
                            <div className="report-container">
                                <DashboardGroupedBarChart
                                    loading={slaTicketResolutionDataLoading}
                                    groupedBarChartData={slaTicketResolutionData}
                                    graphAxesTitle={DashboardConstants.ResolutionSLAMet}
                                    graphBottomTitle={DashboardConstants.Time}
                                    yAxisthresholds={slaTicketYAxisthresholds}
                                    isPercentage={true}
                                    headers={tableHeaders.slaTicketResponseDownloadbaleHeader}
                                    hideDownloadButton={true}
                                    toolbarEnabled={true}
                                />
                            </div>
                        </div>
                        <div className="sla-table-container">
                            <div className="sla-table bold-border-table nested-table">
                                <DashboardTable loading={slaTicketTableDataLoading} rows={slaTicketTableData} headers={tableHeaders.slaByPriorityTableHeaders}
                                    showPagination={true} isSortable={true} isExpandable={true} />
                            </div>
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.SLAbyFranchise}</div>
                            <div className="download-button">
                                <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={slaFranchiseTableData} headers={tableHeaders.slaByFranchiseTableHeaders} title={DashboardConstants.SLAbyFranchise} filename={DashboardConstants.Export} label={DashboardConstants.SLAbyFranchise} />
                            </div>
                        </div>
                        <div className="tile-view">
                            <div className="report-container">
                                <DashboardGroupedBarChart
                                    loading={slaByFranchiseLoading}
                                    groupedBarChartData={slaFranchiseResponseData}
                                    graphAxesTitle={DashboardConstants.ResponseSLAMet}//"Response SLA Met %"
                                    graphBottomTitle={DashboardConstants.Franchise}
                                    hideDownloadButton={true}
                                    toolbarEnabled={true}
                                />
                            </div>
                            <div className="report-container">
                                <DashboardGroupedBarChart
                                    loading={slaByFranchiseLoading}
                                    groupedBarChartData={slaFranchiseResolutionData}
                                    graphAxesTitle={DashboardConstants.ResolutionSLAMet} //"Resolution SLA Met %"
                                    graphBottomTitle={DashboardConstants.Franchise}
                                    hideDownloadButton={true}
                                    toolbarEnabled={true}
                                />
                            </div>
                        </div>
                        <div className="sla-table-container">
                            <div className="sla-table bold-border-table nested-table">
                                <DashboardTable loading={slaByFranchiseLoading} rows={slaFranchiseTableData} headers={tableHeaders.slaByFranchiseTableHeaders}
                                    showPagination={true} isSortable={true} isExpandable={true} />
                            </div>
                        </div>
                    </section>
                    {config.URL.includes(config.unilever) ?
                        <section className="border-bottom sla-incident-table">
                            <div className="graph-title carbon-display-Regular-20">
                                <div className='title'>{DashboardConstants.SLAByIncidents}</div>
                                <div className="download-button">
                                    <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={slaByIncidentDownloadData} headers={tableHeaders.slaByIncidentTableHeaders} title={"SLA by Incidents"} filename={DashboardConstants.Export} label={DashboardConstants.SLAbyFranchise} />
                                </div>
                            </div>
                            <div className="incident-table">
                                <div className="bold-border-table nested-table">
                                    <DashboardTable loading={slaByIncidentLoading} rows={slaByIncidentData} headers={tableHeaders.slaByIncidentTableHeaders}
                                        showPagination={true} isSortable={true} size="normal" getPages={getPages} totalItems={TotalItems} handleNextClick={handleNextClick} paginateRecords={true} />
                                </div>
                            </div>
                        </section>  : ""
                    }
                </div>
            </div>
        </div>
    );
};
export default SLACompliance;
